export default {"src":"/_next/static/media/logo.6d99db5a.svg","height":36,"width":288};